import { SVGProps } from 'react'

export const WpsUndoSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      clipRule='evenodd'
      d='M1.313 3.497a.7.7 0 00.013 1.175l3.582 2.263a.7.7 0 001.074-.591V4.75h3.143a4.375 4.375 0 010 8.75H5.75a.75.75 0 000 1.5h3.375a5.875 5.875 0 100-11.75H5.982V1.701a.7.7 0 00-1.088-.583L1.313 3.497z'
    />
  </svg>
)
